module.exports = __webpack_public_path__ + "fonts/CCDashDecentW00-Heavy.f1e97011.ttf";